import { z } from 'zod';

import { AddressSchema } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/schemas/AddressSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const BusinessAddressDetailsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      businessAddress: AddressSchema(t),
    })
    .strict();

export type BusinessAddressDetailsFormType = z.infer<ReturnType<typeof BusinessAddressDetailsFormSchema>>;
